import styled from 'styled-components';

import ChatFeedContainer from '../ChatFeedContainer';
import MultipleChannelList from '../MultipleChannelView/MultipleChannelList';
import colors from '../../../../../styles/colors';

const ChannelViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  color: ${colors.base.beta};
  overflow: hidden;
`;

const StyledMultipleChannelList = styled(MultipleChannelList)`
  width: 100% !important;
`;

const StyledChatFeedContainer = styled(ChatFeedContainer)`
  width: 100%;
`;

export {
  ChannelViewContainer,
  StyledMultipleChannelList,
  StyledChatFeedContainer,
};
